import React from "react";
import { Box, Text, Button, useBreakpointValue } from '@chakra-ui/react'
import { keyframes } from '@emotion/react';

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;

const Action = () => {
  return (
    <Box textAlign="center" py={10} px={2} bg={'blackAlpha.800'} >
      <Text color={'white'} mb={6} fontSize={useBreakpointValue({ base: 'md', md: '2xl' })} w={'100%'}>
        Es-tu prêt à rejoindre la révolution bancaire ?
      </Text>

      <Button
        as={'a'}
        href="#form"
        bg={'#FFD700'}
        rounded={'full'}
        color={'black'}
        _hover={{ 
          bg: '#ffd900cc',
          transform: 'translateY(-2px)',
          boxShadow: 'lg',
        }}
        animation={`${pulse} 2s infinite ease-in-out`}>
          Rejoins-nous maintenant
      </Button>
    </Box>
  )
}

export default Action;